export default class IHGoogleAnalytics {
  
  static extended(core) {
    
    $(core).on('ready', () => {
      
      const code = core.googleAnalyticsCode;
      const isProduction = core.isProduction;
      
      if (!isProduction || !code) {
        return;
      }
  
      if (window.location.host === 'localhost') {
        ga('create', code, {
          cookieDomain: 'none'
        });
      } else {
        ga('create', code, 'kansai-u.ac.jp');
        ga('send', 'pageview');
      }
      
    });
    
  }
  
}

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');


// WEBPACK FOOTER //
// ./map/js/ih/modules/IHGoogleAnalytics.js